import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import { FieldViewType } from "../viewType";
import fieldsDictionary from "../fieldsDictionary";
import FunctionFieldDetail from "./detail";
import FunctionFieldEdit from "./edit";
import "./reminders/edit";
import "./reminders/detail";
/** <b>Composant qui contient l'affichage d'un champ de type function en: </b>
 *  <li>Liste</li>
 *  <li>Détails</li>
 *  <li>Édition</li>
 */
export function Function() {
    return _jsx(_Fragment, { children: "Link" });
}
var field = fieldsType.function;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, FunctionFieldDetail);
fieldsDictionary.registerField(FieldViewType.EDIT, field, FunctionFieldEdit);
